var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppState from "../../AppState";
import onePlatformSystemError from "./onePlatformSystemError";
const onePlatformStampPromo = (quoteId, actionObjectId, promoCode, quoteItemId, validPromoData) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { settings } = drupalJsObjects;
    const { onePlatformApiRoot, onePlatformApiQuote, onePlatformApiClientId, onePlatformApiClientSecret, token } = settings;
    const checkActionObjectIdExists = (arr, actionObjectId) => {
        return arr.some((obj) => obj.actionObjectId === actionObjectId);
    };
    const actionData = validPromoData.pattern[0].action;
    if (checkActionObjectIdExists(actionData, actionObjectId)) {
        const quoteData = {
            action: 'add',
            promocode: promoCode,
            quoteItemId: quoteItemId
        };
        try {
            return fetch(`${onePlatformApiRoot}${onePlatformApiQuote}/${quoteId}/promo`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'client_secret': `${onePlatformApiClientSecret}`,
                    'client_id': `${onePlatformApiClientId}`
                },
                body: JSON.stringify(quoteData)
            }).then((response) => __awaiter(void 0, void 0, void 0, function* () {
                const isPosted = response.status >= 400 && response.status < 500;
                if (isPosted) {
                    console.info("Promo has already been posted previously.");
                }
                if (!response.ok && !isPosted) {
                    onePlatformSystemError();
                }
                else {
                    return yield response.json();
                }
            }));
        }
        catch (error) {
            console.error('Error stamping promo to quote.');
        }
    }
    return false;
};
export default onePlatformStampPromo;
